module.exports = __webpack_public_path__ + "img/L_297_0.dd78b526.png";